export default "__VITE_ASSET__Bm44D0XG__"